import { render, staticRenderFns } from "./spaceAuthority.vue?vue&type=template&id=1a92f17f&scoped=true&"
import script from "./spaceAuthority.vue?vue&type=script&lang=js&"
export * from "./spaceAuthority.vue?vue&type=script&lang=js&"
import style0 from "./spaceAuthority.vue?vue&type=style&index=0&id=1a92f17f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a92f17f",
  null
  
)

export default component.exports